<template>
  <b-button
    type="is-primary"
    class="button"
    @click="this.exporter">
    <b-icon pack="fas" icon="file-excel"/>
     <span>{{' '}}{{$t("insight.exporter_xls")}}</span>
  </b-button>
</template>

<script>
export default {
  props: ['url_moderateur'],

  methods: {
    exporter () {
      window.open(
        process.env.VUE_APP_URL_SSO_API + 'insight/insight/ExportXLS/' + this.url_moderateur
      )
    }
  }
}
</script>

<style scoped>
.button {
  color:white;
  border-radius:0px;
  font-size:12px;
  width:150px;
  margin:5px;
}
</style>
